.DisplayName {
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: bottom;
    font-weight: 500;

    &.hasHover {
        &:hover,
        &:focus {
            text-decoration: underline;
        }
    }
}
